import { Trans, useTranslation } from "react-i18next";

import { Text } from "@krea/shared/design-system/Text";

/** Body of the estimate accordion for the high/low tiers: how to improve the chances. */
export const ImproveChancesContent = ({
  onContactUs,
}: {
  onContactUs?: () => void;
}) => {
  const { t } = useTranslation("loanWidget");

  return (
    <>
      <p className="text-base-strong mb-2 mt-0">
        {t("loanWidget.improveYourChancesTitle")}
      </p>
      <Text className="text-sm">
        {t("loanWidget.improveYourChancesIntro")}
        <br />
        <br />
        {t("loanWidget.improveYourChancesLargerAmounts")}
        <br />
        <br />
        <ul className="list-disc pl-5 mb-2">
          <li>
            <strong>{t("loanWidget.improveYourChancesBullet1Question")}</strong>{" "}
            {t("loanWidget.improveYourChancesBullet1Text")}
          </li>
          <li>
            <strong>{t("loanWidget.improveYourChancesBullet2Question")}</strong>{" "}
            {t("loanWidget.improveYourChancesBullet2Text")}
          </li>
          <li>
            <strong>{t("loanWidget.improveYourChancesBullet3Question")}</strong>{" "}
            {t("loanWidget.improveYourChancesBullet3Text")}
          </li>
        </ul>
        {t("loanWidget.improveYourChancesReasonableAmount")}
        {onContactUs && (
          <>
            <br />
            <br />
            <Trans
              ns="loanWidget"
              i18nKey="loanWidget.improveYourChancesContactUs"
              components={{
                contactLink: (
                  <button
                    type="button"
                    onClick={onContactUs}
                    className="text-primary underline p-0 bg-transparent border-0 cursor-pointer font-normal"
                  />
                ),
              }}
            />
          </>
        )}
      </Text>
    </>
  );
};
